import type { CheckoutDinnerVouchersService } from '@/scopes/checkout/domain/types'
import { produce } from 'immer'

export function updateDinnerVouchersQuantity(payload: { quantity: number, value: string | null }) {
  return produce((service: CheckoutDinnerVouchersService) => {
    service.selectedQuantity = payload.quantity
    service.selectedValue = payload.quantity > 0 ? payload.value : null
  })
}
